import React from 'react'
import { Modal } from '../../../components/Modal/Modal'
import './UpdateAllMeetingTypesModal.scss'

export interface UpdateAllMeetingTypesModalProps {
  show: boolean
  onHide: () => void
  onConfirm: () => void
  isLoading?: boolean
}

export const UpdateAllMeetingTypesModal: React.FC<UpdateAllMeetingTypesModalProps> = ({ show, onHide, onConfirm, isLoading = false }) => {
  const body = (
    <div className='update-all-meeting-types-modal__body'>
      <p className='update-all-meeting-types-modal__text'>
        New meeting types will apply to future meetings and preps. Anything already generated won't be affected.
      </p>
      <p className='update-all-meeting-types-modal__text mb-0'>Back up agenda and scorecard customizations before updating.</p>
    </div>
  )

  return (
    <Modal
      className='update-all-meeting-types-modal'
      show={show}
      onHide={onHide}
      header={<span className='update-all-meeting-types-modal__title'>Update all system meeting types?</span>}
      body={body}
      centered
      showFooterActions
      footerPrimaryActionTitle='Update all Meeting Types'
      onFooterPrimaryAction={onConfirm}
      footerPrimaryActionLoading={isLoading}
      footerPrimaryActionDisabled={isLoading}
      footerSecondaryActionDisabled={isLoading}
    />
  )
}
